export var HdsIconlibrary_8px;
(function (HdsIconlibrary_8px) {
    HdsIconlibrary_8px["CoreUiCheckmarkSolid_8px"] = "core-ui-checkmark_solid_8px";
    HdsIconlibrary_8px["CoreUiChevronDownSolid_8px"] = "core-ui-chevron-down_solid_8px";
    HdsIconlibrary_8px["CoreUiChevronLeftSolid_8px"] = "core-ui-chevron-left_solid_8px";
    HdsIconlibrary_8px["CoreUiChevronRightSolid_8px"] = "core-ui-chevron-right_solid_8px";
    HdsIconlibrary_8px["CoreUiChevronUpSolid_8px"] = "core-ui-chevron-up_solid_8px";
    HdsIconlibrary_8px["CoreUiCrossSolid_8px"] = "core-ui-cross_solid_8px";
    HdsIconlibrary_8px["CoreUiExternalLinkSolid_8px"] = "core-ui-external-link_solid_8px";
    HdsIconlibrary_8px["CoreUiInformationSolid_8px"] = "core-ui-information_solid_8px";
    HdsIconlibrary_8px["CoreUiLockSolid_8px"] = "core-ui-lock_solid_8px";
    HdsIconlibrary_8px["CoreUiMinusSolid_8px"] = "core-ui-minus_solid_8px";
    HdsIconlibrary_8px["CoreUiOpenWindowSolid_8px"] = "core-ui-open-window_solid_8px";
    HdsIconlibrary_8px["CoreUiOverflowHoriCenterSolid_8px"] = "core-ui-overflow-hori-center_solid_8px";
    HdsIconlibrary_8px["CoreUiOverflowVertCenterSolid_8px"] = "core-ui-overflow-vert-center_solid_8px";
    HdsIconlibrary_8px["CoreUiOverflowVertRightSolid_8px"] = "core-ui-overflow-vert-right_solid_8px";
    HdsIconlibrary_8px["CoreUiPlusSolid_8px"] = "core-ui-plus_solid_8px";
    HdsIconlibrary_8px["CoreUiPopUpWindowSolid_8px"] = "core-ui-pop-up-window_solid_8px";
    HdsIconlibrary_8px["CoreUiProfileSolid_8px"] = "core-ui-profile_solid_8px";
    HdsIconlibrary_8px["CoreUiUnlockSolid_8px"] = "core-ui-unlock_solid_8px";
    HdsIconlibrary_8px["FileCopySolid_8px"] = "file-copy_solid_8px";
    HdsIconlibrary_8px["MapViewDotIndicatorSolid_8px"] = "map-view-dot-indicator_solid_8px";
    HdsIconlibrary_8px["MapViewEastCharacterSolid_8px"] = "map-view-east-character_solid_8px";
    HdsIconlibrary_8px["MapViewNorthCharacterSolid_8px"] = "map-view-north-character_solid_8px";
    HdsIconlibrary_8px["MapViewNorthUpSolid_8px"] = "map-view-north-up_solid_8px";
    HdsIconlibrary_8px["MapViewSouthCharacterSolid_8px"] = "map-view-south-character_solid_8px";
    HdsIconlibrary_8px["MapViewWestCharacterSolid_8px"] = "map-view-west-character_solid_8px";
    HdsIconlibrary_8px["NavigationImagePauseSolid_8px"] = "navigation-image-pause_solid_8px";
    HdsIconlibrary_8px["NavigationImagePlaySolid_8px"] = "navigation-image-play_solid_8px";
    HdsIconlibrary_8px["NavigationImagePlayReverseSolid_8px"] = "navigation-image-play-reverse_solid_8px";
    HdsIconlibrary_8px["NavigationImageStopSolid_8px"] = "navigation-image-stop_solid_8px";
    HdsIconlibrary_8px["StatsMarkerSolid_8px"] = "stats-marker_solid_8px";
    HdsIconlibrary_8px["ThirdPartyLogosWhat_3WordsOutline_8px"] = "third-party-logos-what-3-words_outline_8px";
    HdsIconlibrary_8px["ThirdPartyLogosWhat_3WordsSolid_8px"] = "third-party-logos-what-3-words_solid_8px";
    HdsIconlibrary_8px["TravelTransportTrackingAttentionSolid_8px"] = "travel-transport-tracking-attention_solid_8px";
})(HdsIconlibrary_8px = HdsIconlibrary_8px || (HdsIconlibrary_8px = {}));
export const HDS_ICONLIBRARY_8PX_CODEPOINTS = {
    [HdsIconlibrary_8px.CoreUiCheckmarkSolid_8px]: '61697',
    [HdsIconlibrary_8px.CoreUiChevronDownSolid_8px]: '61698',
    [HdsIconlibrary_8px.CoreUiChevronLeftSolid_8px]: '61699',
    [HdsIconlibrary_8px.CoreUiChevronRightSolid_8px]: '61700',
    [HdsIconlibrary_8px.CoreUiChevronUpSolid_8px]: '61701',
    [HdsIconlibrary_8px.CoreUiCrossSolid_8px]: '61702',
    [HdsIconlibrary_8px.CoreUiExternalLinkSolid_8px]: '61703',
    [HdsIconlibrary_8px.CoreUiInformationSolid_8px]: '61704',
    [HdsIconlibrary_8px.CoreUiLockSolid_8px]: '61705',
    [HdsIconlibrary_8px.CoreUiMinusSolid_8px]: '61706',
    [HdsIconlibrary_8px.CoreUiOpenWindowSolid_8px]: '61707',
    [HdsIconlibrary_8px.CoreUiOverflowHoriCenterSolid_8px]: '61708',
    [HdsIconlibrary_8px.CoreUiOverflowVertCenterSolid_8px]: '61709',
    [HdsIconlibrary_8px.CoreUiOverflowVertRightSolid_8px]: '61710',
    [HdsIconlibrary_8px.CoreUiPlusSolid_8px]: '61711',
    [HdsIconlibrary_8px.CoreUiPopUpWindowSolid_8px]: '61712',
    [HdsIconlibrary_8px.CoreUiProfileSolid_8px]: '61713',
    [HdsIconlibrary_8px.CoreUiUnlockSolid_8px]: '61714',
    [HdsIconlibrary_8px.FileCopySolid_8px]: '61715',
    [HdsIconlibrary_8px.MapViewDotIndicatorSolid_8px]: '61716',
    [HdsIconlibrary_8px.MapViewEastCharacterSolid_8px]: '61717',
    [HdsIconlibrary_8px.MapViewNorthCharacterSolid_8px]: '61718',
    [HdsIconlibrary_8px.MapViewNorthUpSolid_8px]: '61719',
    [HdsIconlibrary_8px.MapViewSouthCharacterSolid_8px]: '61720',
    [HdsIconlibrary_8px.MapViewWestCharacterSolid_8px]: '61721',
    [HdsIconlibrary_8px.NavigationImagePauseSolid_8px]: '61722',
    [HdsIconlibrary_8px.NavigationImagePlaySolid_8px]: '61723',
    [HdsIconlibrary_8px.NavigationImagePlayReverseSolid_8px]: '61724',
    [HdsIconlibrary_8px.NavigationImageStopSolid_8px]: '61725',
    [HdsIconlibrary_8px.StatsMarkerSolid_8px]: '61726',
    [HdsIconlibrary_8px.ThirdPartyLogosWhat_3WordsOutline_8px]: '61727',
    [HdsIconlibrary_8px.ThirdPartyLogosWhat_3WordsSolid_8px]: '61728',
    [HdsIconlibrary_8px.TravelTransportTrackingAttentionSolid_8px]: '61729',
};
//# sourceMappingURL=hds-iconlibrary-8px.js.map